// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3OnFX","left":"StickyBox_left__68ws1","right":"StickyBox_right__3DEmc"};